import { createFileRoute } from '@tanstack/react-router';

import { GcsUploadItemView } from '#/features/community-hub/components/block-viewers/gcs-upload-item-view';

export const Route = createFileRoute('/_protected/programs/$programSlug/$moduleSlug/$lessonSlug/gcs-upload/$itemSlug')({
  component: GcsUploadContentRoute,
});

function GcsUploadContentRoute() {
  const { itemSlug } = Route.useParams();
  // Keyed so opening another item remounts the view instead of keeping the last item's state.
  return <GcsUploadItemView key={itemSlug} itemSlug={itemSlug} />;
}
